import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import Modal from '@/common/components/Modal/Modal';
import TreeItemTitle from '@/common/components/TreeItemModal/TreeItemTitle/TreeItemTitle';
import { withStores } from '@/common/hoc/withStores';
import Notifier from '@/common/services/Notifier';
import { useAppStore } from '@/common/stores/AppStore';
import DriveItemModalTree from '@/drive/components/DriveItemModal/DriveItemModalTree/DriveItemModalTree';
import DriveItemModalTreeStore, { useDriveItemModalTreeStore, } from '@/drive/components/DriveItemModal/DriveItemModalTree/DriveItemModalTreeStore';
import { getDriveItemId } from '@/drive/components/DriveItemModal/DriveItemModalTree/DriveItemModalTreeStore.utils';
import { useDriveItemModalForm } from '@/drive/components/DriveItemModal/useDriveItemModalForm';
import DriveItemModalFooter from '@/drive/components/DriveItemModalFooter/DriveItemModalFooter';
import DriveItemModalForm from '@/drive/components/DriveItemModalForm/DriveItemModalForm';
import DriveItemPreview from '@/drive/components/DriveItemPreview/DriveItemPreview';
import { DriveItemType } from '@/drive/entities/DriveItem';
import DriveItemModalStore, { useDriveItemModalStore } from '@/drive/stores/DriveItemModalStore';
import { createEmptyForm } from '@/drive/types/driveItemModalFormData';
import { isSmScreen } from '@/forwarding/components/Forwarder/ForwardModal/ForwardModal.utils';
import { MediaSize } from '@/media/constants/sizeCodes';
import styles from './DriveItemModal.module.less';
function DriveItemModal(props) {
    const { config, onClose, onSuccess, onBack, usePortal } = props;
    const { screenWidth } = useAppStore();
    const driveItemModalStore = useDriveItemModalStore();
    const driveItemModalTreeStore = useDriveItemModalTreeStore();
    useEffect(() => {
        if (config) {
            driveItemModalTreeStore.refresh();
        }
        else {
            driveItemModalTreeStore.reset();
        }
    }, [config]);
    const initialForm = useMemo(() => (config ? config.getForm() : createEmptyForm()), [config]);
    const { values, errors, handleSubmit, setFieldValue } = useDriveItemModalForm(async (formValues) => {
        if (!config) {
            return;
        }
        if (!driveItemModalTreeStore.selectedId) {
            Notifier.warn('Select Folder');
            return;
        }
        if (driveItemModalTreeStore.newItem) {
            await driveItemModalTreeStore.finishCreation();
        }
        const { success } = await driveItemModalStore.submit(config, formValues, getDriveItemId(driveItemModalTreeStore.selectedId));
        if (success) {
            onClose?.();
            onSuccess?.();
        }
    }, initialForm, config?.formDisabled());
    const collectionProductType = config?.getCollectionReqData()?.type;
    return (_jsxs(Modal, { usePortal: usePortal, isShowed: !!config, onClose: onClose, title: _jsx(TreeItemTitle, { title: "Copy to Cutwise Drive", filterShown: false, onBack: onBack }), renderModalFooter: () => (_jsx(DriveItemModalFooter, { onAddFolder: () => driveItemModalTreeStore.startCreation({ type: DriveItemType.Folder }), onAddCollection: () => collectionProductType &&
                driveItemModalTreeStore.startCreation({
                    type: DriveItemType.Collection,
                    productType: collectionProductType,
                }), collectionProductType: collectionProductType })), contentClassName: styles.driveItemModal, children: [_jsx("div", { className: styles.treeContainer, children: _jsx(DriveItemModalTree, {}) }), _jsx("div", { className: styles.formContainer, children: _jsxs("div", { className: styles.rightContainer, children: [config && (_jsx(DriveItemPreview, { preview: config.getPreview(), mediaSize: isSmScreen(screenWidth) ? MediaSize.XSmall : MediaSize.Small })), _jsx(DriveItemModalForm, { values: values, errors: errors, hideLabels: isSmScreen(screenWidth), notePlaceholder: isSmScreen(screenWidth) ? 'Type your note here' : '', disabled: config?.formDisabled(), setFieldValue: setFieldValue, onReset: onClose, onSubmit: handleSubmit, autoFocusField: isSmScreen(screenWidth) ? null : 'title' })] }) })] }));
}
export default withStores(({ driveModifierStore }) => ({
    driveItemModalStore: new DriveItemModalStore(driveModifierStore),
    driveItemModalTreeStore: new DriveItemModalTreeStore(driveModifierStore),
}), observer(DriveItemModal));
